<script lang="ts">
    import type ServiceProvider from '../services/service.provider'
    import List from './List.svelte'

    export let serviceProvider: ServiceProvider

    let searchActive = false

    serviceProvider.documentService.activeSubs.subscribe((status) => (searchActive = status))
</script>

{#if searchActive}
    <List {serviceProvider}/>
{/if}
